module.exports = __webpack_public_path__ + "static/media/create-page-wizard3.8eb278fc.png";